import Login from 'modules/auth/login';
import AuthWrapper from '../authWrapper';

const LoginPage = () => {
  return (
    <AuthWrapper>
      <Login />
    </AuthWrapper>
  );
};

export default LoginPage;
